// extracted by mini-css-extract-plugin
module.exports = {"width100":"s_dm h_dm","design3Pos":"s_r1 h_dR"};